import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ManageBlogGridLoader from "./ManageBlogsGridLoader";
import {tryLoadTags} from "../../../redux/slices/manageBlogSlice";
import {BLOG_TAB_TAGS, TAGS_ITEMS_PER_PAGE} from "../constants";
import BlogTag from "./BlogTag";


export default function BlogTagsGrid() {


  const currentPage = useSelector((state) => state.manageBlogs[BLOG_TAB_TAGS].meta.page);


  const {
    loading = false, init = false, data: tags = [], error = ""

  } = useSelector((state) => state.manageBlogs[BLOG_TAB_TAGS].pageData[currentPage]) ?? {};

  const dispatch = useDispatch();


  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(tryLoadTags({type: BLOG_TAB_TAGS}));
  }, [init, loading, error]);


  return (
    <>
      {
        init && !!tags.length ?


          tags.map((tag) => <BlogTag tag={tag} key={tag.id} backgroundColor="bg-neutral cursor-pointer"/>)

          :
          <ManageBlogGridLoader error={error} retry={() => dispatch(tryLoadTags({type: BLOG_TAB_TAGS}))}
                                empty={init && !tags.length}
                                count={TAGS_ITEMS_PER_PAGE} isTag={true}/>
      }


    </>


  );
}

